import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { workingDayService } from '@/api/domains/workingDay';
import { useExport } from '@/hooks/ui/useExport';
import { useUI } from '@/hooks/ui/useUI';
import type { UIExportFormat } from '@/types/fileExport.types';


export interface UseWorkingDayExportResult {
  onExport: (format: UIExportFormat) => Promise<void>;
  isExporting: boolean;
}

export function useWorkingDayExport(): UseWorkingDayExportResult {
  const { t: translate } = useTranslation();
  const { showNotification } = useUI();

  const { onExport: exportFile, isExporting } = useExport({
    exportFn: () => workingDayService.export(),
    successMessage: translate('schedule:workingDay.messages.exportSuccess'),
    errorMessage: translate('schedule:workingDay.messages.exportError'),
  });

  const onExport = useCallback(async (format: UIExportFormat) => {
    if (format !== 'EXCEL') {
      showNotification('error', translate('schedule:workingDay.messages.exportError'));
      return;
    }
    await exportFile();
  }, [exportFile, showNotification, translate]);

  return { onExport, isExporting };
}

export default useWorkingDayExport;
